import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { motion } from "framer-motion"

const HeroComp = () => {
    return ( 
  <>
     <div className="main_cont fixed-top">
          <nav className=" pe-3 mobile_cont d-none nav_cont">
            <ul>
                <a href="#home"><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline" style={{"width":"15%"}}/></a> 
              <div className="d-inline pt-4" style={{"float":"right","letterSpacing":"4px"}}>
              <Link to={"/templates"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center activ_box" > <p className="activ">Free Offer</p></div></Link>
              <Link to={"/"}  className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Home</div></Link>
              <Link to={"/templates"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Websites</div></Link>
              <Link to={"/about"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >About</div></Link>
              <Link to={"/policy"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Policy</div></Link>
              <a href="#contact" className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Contact</div></a>
              </div>
            </ul>
          </nav>
        

<nav className="mobile_cont d-md-none fixed-top">
<button style={{"background":"none"}} className="btn btn-white ms-3 my-4" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions"><i className="fa fa-bars" style={{"fontSize":"30px"}} aria-hidden="true"></i>
</button> <Link to={'/signin'}><button style={{"background":"none"}} className="btn btn-white" type="button" ><i class="fa fa-phone fw-bold text-success" style={{"fontSize":"30px"}} aria-hidden="true"></i></button></Link>
<a href='#home'><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline mx-5 my-4" style={{"width":"25%", "float":"right","transform":"scale(1.9)"}}/></a>
<div className="offcanvas offcanvas-start w-50" data-bs-scroll="true" tabindex="-1" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
  <div className="offcanvas-header">
    <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel"><Link><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline" style={{"width":"60%", "float":"left","transform":"scale(1.8)"}}/></Link>
</h5>
    <button type="button" className="btn-close btn-danger" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="mob offcanvas-body text-white" style={{ backgroundColor: "#E52020", textAlign: "center" }}>
  <Link to={"/templates"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Offer
    </div>
  </Link>
  <Link to={"/"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Home
    </div>
  </Link>
  <Link to={"/templates"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Websites
    </div>
  </Link>
  <Link to={"/about"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
       About
    </div>
  </Link>
  <Link to="/policy" style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
       Policy
    </div>
  </Link>
  <a href={"#contact"} style={{ textDecoration: "none" }}>
    <div className="a_log w-100 p-3 mt-3 text-white" style={{ fontSize: "20px" }}>
      Contact
    </div>
  </a>
</div>

</div>
</nav>
        </div>
                                           {/*Hero section*/}

<div className="container-fluid hero_section text-center" style={{height: "100%",padding:"220px 0px 50px 0px"}}>  
     <h1 className="text-light fw-bold">Professionally Design Website</h1>
     <p className="text-light my-3 mx-3">Why not speak to a pro to get more customers ? We provide SEO services, marketing, web hosting, and website design for your company. Sign up today and earn yourself <span className="text-warning fs-5" >50% off discount</span>.</p>
     <a href="/templates" className="text-decoration-none mx-2" style={{'fontSize':'1rem'}}><motion.button className="px-4 py-2 mt-3 text-light fw-bold"
     style={{backgroundColor: "#E52020", border:"none", borderRadius:"30px 30px"}}
     whileHover={{ scale: 1.1 }}
      animate={{
        scale: [1, 1.05, 1],
      }}
      transition={{
        duration: 1,
        repeat: Infinity,
        ease: "easeInOut",
      }}
     
     >Get Started &rarr;</motion.button></a>
</div>

<section id="call-to-action" class="wow fadeIn">
      <div class="container text-center">
       <iframe id="Y_iframe" src="https://www.youtube.com/embed/1YZ6HzPij4o" title="Carib Web Works" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        
		 <h3 >Price: <s className="text-danger">Was $62,000.00</s></h3>
        <p>Claim your business website for only <span className="text-success fw-bold">$31,000.00</span>.</p>
        <a href="/templates" className="text-decoration-none mx-2" style={{'fontSize':'1rem'}}><button className="px-4 py-2 mt-3 text-light fw-bold" style={{backgroundColor: "#E52020", border:"none", borderRadius:"30px 30px"}}>Sign Up &rarr;</button></a>
      </div>
  </section>
                                           {/*why do you section*/}
  <div class="container mt-5 text-center">
  <i class="fa fa-globe fs-1" aria-hidden="true"style={{color: "#000080"}}></i>
      <h3>Why Do You Need A Website</h3>
      <hr className="hr_line"></hr>
      <div class="row g-2 mt-3">

<div class="col-sm-4 text-center">
<div class="container b_cont" style={{"width": "100%", height: "200px", overflow: "hidden", }}>
<p className="text-dark text-start" > 
		   With the use of a website, you can establish a powerful online presence that will make it simpler for potential clients to find and learn more about your company.    You can reach a wider audience and have access to a worldwide market by creating a website. It creates possibilities for more sales.</p>
      </div>
<p className="fw-bold text-success">Get More Clients</p>
</div>

<div class="col-sm-4 text-center">
<div class="container b_cont" style={{"width": "100%", height: "200px", overflow: "hidden"}}>
<p className="text-dark text-start" >
A website serves as a potent marketing tool, bringing in traffic and turning browsers into buyers.E-commerce capabilities can be incorporated to promote online sales and broaden revenue sources.
</p>
</div>
<p className="fw-bold text-success">Boost Sales and Revenue</p>
</div>

<div class="col-sm-4 text-center">
<div class="container b_cont" style={{"width": "100%", height: "200px", overflow: "hidden"}}>
<p className="text-dark text-start" >
Having a website distinguishes your company from those that are still only using conventional marketing techniques in the cutthroat business environment of today.It demonstrates that you stay current with fashion and technology.Having a website distinguishes your company.
  </p>
  </div>
<p className="fw-bold text-success">Stay Ahead of Competitors</p>
</div>
</div>
</div>
                                          
<div class="container photo_cont mt-3">
  
</div>
                                         {/*about section*/}
<div class="container mt-5 text-center" id="about">
<i class="fa fa-globe fs-1" aria-hidden="true"style={{color: "#000080"}}></i>
<h3>Why Choose Us</h3>
  <hr className="hr_line"></hr>
  <div class="row g-2 mt-2">
    <div class="col-sm-6">
    <div class="container" style={{"width": "100%", height: "400px", overflow: "hidden"}}>
    <img src="/images/workman1.jpg" class="img-fluid" style={{height: "100%","object-fit": "cover",width:"100%"}} />
   </div>
    </div>
    <div class="col-sm-6 b_cont">
      <div class="p-3">
        <div className="text-end px-2">
        <small className="fw-bold" style={{color:"#E52020"}}>Why</small>
        <h3>We are The Best</h3>
        </div>
        <div className="text-start px-2">
          <p> <b>Customized Solutions:</b> We respect the value of specialized approaches. You and our staff will collaborate closely to understand your goals.  target audience, and brand identity, making sure that the website fully satisfies your particular needs.</p>
        </div>
        <div className="text-start px-2">
          <p> <b>Caribbean Expertise:</b> Our team are a locally based business with extensive knowledge of the Caribbean market. We use our in-depth understanding of local culture, tastes, and purchasing habits to build websites that appeal to your target market.</p>
        </div>
      </div>
    </div>
  </div>
</div>
                                
                                          {/*Feature section*/}
  <div class="container mt-5 text-center">
    <i class="fa fa-globe fs-1" aria-hidden="true"style={{color: "#000080"}}></i>
      <h3>Website Features</h3>
      <hr className="hr_line"></hr>
      <div class="row g-2 mt-3">

<div class="col-sm-4 text-center">
<div class="container b_cont" style={{"width": "100%", height: "200px", overflow: "hidden", }}>
<h5>Mobile Responsive</h5>
<img src="/images/fone.jpg" class="img-fluid" style={{height: "100%","object-fit": "cover",width:"100%"}} />
</div>
<div class="b_cont px-2 pb-2" style={{ wordWrap:"break-word"}}>
<p className="text-justify"> It is essential for your website to be mobile-friendly in the modern digital age. At Carib Web Work, we make sure that your website is customized for different mobile devices, giving your customers a smooth surfing experience. Your website will adjust to various screen sizes with a mobile-responsive design, making it simple to use on smartphones and tablets. You may efficiently reach your target audience and increase traffic to your website by catering to the increasing number of mobile users.</p>
</div>
</div>

<div class="col-sm-4 text-center">
<div class="container b_cont" style={{"width": "100%", height: "200px", overflow: "hidden"}}>
<h5>Affordable Website Design</h5>
<img src="/images/payment.jpg" class="img-fluid" style={{height: "100%","object-fit": "cover",width:"100%"}} />
</div>
<div class="b_cont px-2 pb-2" style={{ wordWrap:"break-word"}}>
<p className="text-justify"> Affordable website design services are available from Carib Web Work and are targeted exclusively towards Caribbean companies. We comprehend the particular needs and difficulties that companies operating in the Caribbean, notably in Jamaica, encounter. Our objective is to offer solutions that are both affordable and outstanding in their performance. We collaborate directly with you to develop a magnificent website that captures the essence of your brand.</p>
</div></div>

<div class="col-sm-4 text-center">
<div class="container b_cont" style={{"width": "100%", height: "200px", overflow: "hidden"}}>
<h5>Easy to Navigate</h5>
<img src="/images/mobile.jpg" class="img-fluid" style={{height: "100%","object-fit": "cover",width:"100%"}} />
  </div>
  <div class="b_cont px-2 pb-2" style={{ wordWrap:"break-word"}}>
<p className="text-justify"> Your visitors should be able to swiftly and easily discover the information they need by navigating a well-designed website. Carib Web Work places a high priority on developing user-friendly interfaces and easy navigation menus. We organize and logically organise the content of your website so that viewers may easily navigate between pages and sections. We make sure that your visitors remain interested and become devoted consumers by increasing the user experience through intuitive navigation.</p>
</div></div>
</div>
</div>


<div className="container text-center mt-5">
<i class="fa fa-globe fs-1" aria-hidden="true"style={{color: "#000080"}}></i>
<h3>Our Location</h3>
  <hr className="hr_line"></hr>
  <div className="row mt-2">
      <div className="col">
      <div class="p-3 ">
      <img src="/images/group.png" alt="logo" className="img-fluid" style={{"width":""}}/>     
      </div>
      </div>
  </div>
</div>
                       
                                {/*contact section*/}
<div className="container my-5" id="faq">
      <div className="py-5 px-5 text-center">
      <h3>Frequent Ask Questions</h3>
  <hr className="hr_line"></hr>
      <div className="b_cont mt-3" style={{color:"grey"}}>
      <div>
 <i class="fa fa-globe fs-1" aria-hidden="true"style={{color: "#000080"}}></i>
  <h5>What services does Carib Web Works provide?</h5>
  <p>
    Carib Web Works specializes in creating custom websites tailored to meet your specific needs. 
    We offer web design, maintenance, hosting, and other services.
  </p>

  <h5>How long does it take to create a website?</h5>
  <p>
    The timeline for website development depends on the complexity and requirements of the project. 
    Simple websites can be completed within 24–72 hours, while larger or more complex projects may take several days.
  </p>

  <h5>Will my website be mobile-friendly?</h5>
  <p>
    Absolutely! At Carib Web Works, we ensure that all the websites we create are fully responsive and optimized for mobile devices. 
    Your website will look great and function seamlessly on smartphones, tablets, and desktops.
  </p>

  <h5>What about website hosting and domain registration?</h5>
  <p>
    We provide website hosting services and can also assist with domain registration if you don't have a domain.
  </p>

  <h5>How much does a website from Carib Web Works cost?</h5>
  <p>
    A professional Website offered by Carib Web Works commence at JMD$31,000.00.
  </p>

  <h5>What other services do you charge for?</h5>
  <p>
   We charge for social media marketing, hosting, maintenance and seo services
  </p>
  <h5>What kind of payment do you accept?</h5>
  <p>
    For now, we only accept cash, PayPal and credit/debit card.
  </p>

  <h5>Is my payment information secure?</h5>
  <p>
    Yes, your payment is completely secure because we process it through the PayPal channel. 
    Using the technique that our SSL certificate employs through the hosting provider, all of your information is encrypted.
  </p>

  <h5>Do you offer support?</h5>
  <p>
    Yes, we offer 24/7 support. Send us a message and we will reply as soon as possible.
  </p>
 <div className="back_img py-4">
  <h3  style={{color: "#E52020"}}>Free Consultation</h3>
  <h5 className="text-light">Don't overlook the various benefits of a website, contact us right away!</h5>
  <a href="#contact" className="text-decoration-none mx-2" style={{'fontSize':'1rem'}}><button className="px-4 py-2 mt-3 text-light fw-bold" style={{backgroundColor: "#E52020", border:"none", borderRadius:"30px 30px"}}>Contact Us &rarr;</button></a>
 </div>
</div>

	  
      </div>
      </div>
    </div>
                                             {/*footer section*/}
 <div className="body-footer text-center text-white" id="contact" style={{"backgroundColor":"#E52020"}}>
            <footer className="w-100 py-4 flex-shrink-0">
                <div className="container py-4">
                    <div className="row gy-4 gx-5">
                        <div className="col-lg-4 col-md-6">
                            <h5 className="h1 text-white">Contact Us</h5>
                            <p className="small text-white">Call: (876) 808-9990</p>
                            <p className="small text-white">Watsapp: (876) 808-9990</p>
                            <p className="small text-white">Email: caribwebworks@gmail.com </p>
                            <p className="small text-white">Address: Montego Bay, St. James</p>
                            <p><i class="fa fa-twitter-square me-3" aria-hidden="true"></i> 
                           <i class="fa fa-instagram me-3" aria-hidden="true"></i>
                            <i class="fa fa-facebook-square me-3" aria-hidden="true"></i>
                            </p>   
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <h5 className="text-white mb-3">Menu</h5>
                            <ul className="list-unstyled text-dark">
                                <li><a className="text-warning fw-bold"  href="/">Home</a></li>
                                <li><Link className="text-warning fw-bold"  to={"/about"}>About</Link></li>
                                <li><Link className="text-warning fw-bold"  to={"/policy"}>Policy</Link></li>
                                <li><a className="text-warning fw-bold"  href="#faq" >FAQ</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <h5 className="text-white mb-3">Menu</h5>
                            <ul className="list-unstyled">
                            <li><a className="text-warning fw-bold"  href="/">Home</a></li>
                                <li><Link className="text-warning fw-bold"  to={"/about"}>About</Link></li>
                                <li><Link className="text-warning fw-bold"  to={"/policy"}>Policy</Link></li>
                                <li><a className="text-warning fw-bold"  href="#faq" >FAQ</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-6">
                        <h3 className="h1 text-white">Carib Web Works</h3>
                        <div className="bg-white ">
                            <img src="/images/cc_paypal.png" alt="logo" className="img-fluid d-inline my-3" style={{"width":"55%","transform":"scale(1.3)"}}/>
                          </div>  
                            <p className="small" style={{"color":"gold"}}>"Fast and secure payment methods"</p>
                            <i>By: Ceo & Team</i>
                        </div>
                    </div>
                </div>
                <p className="small text-dark mb-0" id="contact">&copy; Copyrights. All rights reserved. <a className="text-primary" href="/signup" target={'_blank'}>caribwebworks.com</a></p>
            </footer>
                </div>
        </>
     );
}
 
export default HeroComp;